import { combineReducers } from 'redux';
import {authentication} from './authentication.reducer'
// here include reducers
const rootReducer = combineReducers({
    authentication
});

export default rootReducer;